import { selectOrganizationsOrderedByName } from 'services/organizations/selectors';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

const selectOrganizationOptions = createDeepEqualSelector(
    selectOrganizationsOrderedByName,
    (organization) =>
        organization.map((org) => ({
            text: org.name,
            value: org.id,
            key: org.id
        }))
);

export { selectOrganizationOptions };
